export default __webpack_public_path__ + "static/media/space.1fe2a72c.svg";